import { useMemo } from "react";

export default function TimerPanel({ session, elapsed, remaining, fmt }) {
  const planned = session.planned_duration_seconds || 1;
  const pct = useMemo(
    () => Math.min(100, Math.max(0, (elapsed / planned) * 100)),
    [elapsed, planned],
  );

  const overtime = remaining < 0;

  return (
    <div className="card-elevated p-8" data-testid="timer-panel">
      <div className="flex items-center justify-between mb-4">
        <div className="text-[11px] font-mono uppercase tracking-[0.25em] text-white/40">
          {overtime ? "Overtime" : "Time remaining"}
        </div>
        <div className="text-[11px] font-mono text-white/40">
          {fmt(elapsed)} / {fmt(planned)}
        </div>
      </div>

      <div
        className={`font-mono text-7xl md:text-[7vw] font-bold leading-none tracking-tighter ${
          overtime ? "text-[hsl(var(--pink))]" : "timer-glow"
        }`}
        data-testid="timer-display"
      >
        {fmt(overtime ? remaining : Math.max(0, remaining))}
      </div>

      <div className="mt-6 h-1.5 rounded-full bg-white/5 overflow-hidden">
        <div
          className="h-full rounded-full transition-all duration-500 ease-out"
          style={{
            width: `${pct}%`,
            background: overtime
              ? "hsl(var(--pink))"
              : "linear-gradient(90deg, hsl(var(--green)), hsl(var(--green-hi)))",
          }}
          data-testid="timer-progress-bar"
        />
      </div>
    </div>
  );
}
